/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import RenderObject from "App/geometry/objects/object";

export default
class LinkedShapesListItem {
    private _pred: LinkedShapesListItem = null;
    private _anc: LinkedShapesListItem = null;
    private _object: RenderObject = null;

    public buffer: any = {};
    public updates: any = {};
    public placed: boolean = false;

    constructor(aObject: RenderObject) {
        this._object = aObject;
        this.resetPlacement();
    }

    public getObject(): RenderObject
    {
        return this._object;
    }

    public setAnc(anc: LinkedShapesListItem) {
        this._anc = anc;
    }

    public getAnc(): LinkedShapesListItem
    {
        return this._anc;
    }

    public setPred(pred: LinkedShapesListItem) {
        this._pred = pred;
    }

    public getPred(): LinkedShapesListItem
    {
        return this._pred;
    }

    public resetPlacement() {
        this.buffer = {
            vertexOffset: -1,
            indexOffset: -1,
            nonIndexedVertexOffset: -1
        }

        this.updates = {};
        this.placed = false;
    }
}
